module.exports = __webpack_public_path__ + "img/img1.3af0890a.png";